// Single row of the Pipe Take-off project list. Extracted so
// ProjectList.tsx stays under the 150-line cap. The row's name cell
// is a Link to the project detail; the trailing actions cell hosts a
// delete icon-button.
import { Link } from "react-router";
import { Trash2 } from "lucide-react";
import { formatDate } from "../../../lib/utils";

const STATUS_VARIANT: Record<string, string> = {
  pending: "grey",
  uploading: "blue",
  preprocessing: "blue",
  extracting: "blue",
  validating: "blue",
  completed: "green",
  failed: "red",
};

export interface ProjectRowDto {
  id: number;
  name: string;
  description: string | null;
  drawingNumber: string | null;
  pdfFilename: string | null;
  status: string;
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
}

interface Props {
  row: ProjectRowDto;
  deleting: boolean;
  onDelete: (id: number, name: string) => void;
}

export function ProjectListRow({ row, deleting, onDelete }: Props) {
  return (
    <tr style={{ cursor: "pointer" }}>
      <td>
        <Link
          to={`/tools/pipe-takeoff/${row.id}`}
          style={{ color: "inherit", textDecoration: "none" }}
        >
          <div style={{ fontWeight: 600 }}>{row.name}</div>
          {row.description && (
            <div style={{ fontSize: 12, color: "var(--bsp-fg-muted)" }}>
              {row.description}
            </div>
          )}
        </Link>
      </td>
      <td className="bsp-mono" style={{ fontSize: 12 }}>
        {row.drawingNumber ?? "—"}
      </td>
      <td style={{ fontSize: 12 }}>{row.pdfFilename ?? "—"}</td>
      <td>
        <span
          className={`bsp-chip bsp-chip-${STATUS_VARIANT[row.status] ?? "grey"}`}
        >
          {row.status}
        </span>
      </td>
      <td className="bsp-mono" style={{ fontSize: 12 }}>
        {formatDate(row.createdAt)}
      </td>
      <td style={{ width: 36, textAlign: "right" }}>
        <button
          type="button"
          className="bsp-btn bsp-btn-ghost bsp-btn-icon"
          title="Delete project"
          aria-label={`Delete project ${row.name}`}
          disabled={deleting}
          onClick={() => onDelete(row.id, row.name)}
        >
          <Trash2 size={14} />
        </button>
      </td>
    </tr>
  );
}
